import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";
import { updateOpeningApplicant } from "./api";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { employee, resume_url, ...rest } = values;

    const payload = Object.fromEntries(
        Object.entries(rest).filter(([key, value]) => {
            if (value === undefined) return false;
            if (value === "" || value === null) return key === "resume_url";
            return true;
        })
    );

    if (Object.prototype.hasOwnProperty.call(values, "resume_url")) {
        payload.resume_url = resume_url === "" ? null : resume_url;
    }

    if (employee !== undefined) {
        payload.employee = employee?.id;
    }

    return payload;
}

export function useUpdateOpeningApplicant() {
    return useMutation({
        mutationFn: async ({ applicantId, values }) => {
            const payload = buildPayload(values);

            try {
                const response = await updateOpeningApplicant({ applicantId, item: payload });
                return response;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Applicant updated successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
